import { Navigate, Outlet, useLocation } from 'react-router-dom';

const ComponentNavigate = () => {
    const { pathname } = useLocation();

    if (pathname === '/attachment') {
        return <Navigate to="/attachment/attachments" />;
    }

    if (pathname === '/wallpaper') {
        return <Navigate to="/wallpaper/posts" />;
    }

    // 系统管理
    if (pathname === '/system-management') {
        return <Navigate to="/system-management/users" />;
    }

    return <Outlet />;
};

export default ComponentNavigate;
